import { Schema } from 'yup';

export const emptyStringToNullTransform = (value: unknown, originalValue: unknown): unknown =>
    String(originalValue).trim() === '' ? null : value;

export const toStringSchema = (value: unknown): Schema<string> => value as Schema<string>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const nullBoolToFalse = (value: any): boolean => !!value;
